/* Mini-carrusel de imagenes de la tarjeta de producto (solo movil).
 *
 * 27-jul. ANTES: este codigo vivia como <script> incrustado DENTRO de
 * snippets/card-product.liquid, asi que se emitia una vez por tarjeta:
 *   - 50 copias identicas en /collections/all = 74,2 KB de HTML duplicado
 *   - cada copia recorria TODOS los .product-slider del documento, asi que en una
 *     coleccion de 50 productos se hacian 50 x 50 = 2.500 inicializaciones
 *   - cada flecha acababa con 50 listeners de click: un toque disparaba 50 scrollBy
 *     seguidos y el carrusel SALTABA AL FINAL en vez de avanzar una foto
 *   - al filtrar u ordenar, las tarjetas nuevas se quedaban sin listeners
 *
 * AHORA: un solo fichero, un solo listener por tipo de evento, delegados en document.
 * Funciona tambien con las tarjetas que llegan despues (filtros, "cargar mas", drawers).
 */
(function () {
  'use strict';
  if (window.__ewCardSliderInit) return;
  window.__ewCardSliderInit = true;

  function updateProgress(slider) {
    var wrap = slider.parentElement;
    if (!wrap) return;
    var bar = wrap.querySelector('.slider-progress-bar');
    if (!bar) return;
    var total = slider.querySelectorAll('.product-slide').length;
    if (total <= 1) return;
    var w = slider.clientWidth || 1;
    var index = Math.round(slider.scrollLeft / w);
    bar.style.width = (((index + 1) / total) * 100) + '%';
  }

  /* El evento scroll no burbujea: se escucha en fase de captura.
     Un unico listener para toda la pagina, limitado a un frame. */
  var ticking = false;
  document.addEventListener('scroll', function (e) {
    var el = e.target;
    if (!el || !el.classList || !el.classList.contains('product-slider')) return;
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      updateProgress(el);
    });
  }, true);

  /* Flechas, tambien delegadas: un solo listener para todas las tarjetas. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('.slider-arrow');
    if (!btn) return;
    var wrap = btn.closest('.product-card__mobile-slider');
    if (!wrap) return;
    var slider = wrap.querySelector('.product-slider');
    if (!slider) return;
    e.preventDefault();
    var dir = btn.classList.contains('slider-arrow--prev') ? -1 : 1;
    slider.scrollBy({ left: dir * slider.clientWidth, behavior: 'smooth' });
  });

  /* Estado inicial de las barras ya presentes. Las tarjetas que lleguen despues
     arrancan con el 33,333 % que define el CSS y se corrigen al primer desplazamiento. */
  function initAll() {
    var list = document.querySelectorAll('.product-slider');
    for (var i = 0; i < list.length; i++) updateProgress(list[i]);
  }
  window.ewInitCardSliders = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
